import React, { useState } from 'react';
import './AccordionFieldset.css'; // assuming styles are in this file

const AccordionFieldset = ({ title, children, collapsed }) => {
  const [isCollapsed, setIsCollapsed] = useState(collapsed??true);

  return (
    <fieldset className={`accordion-fieldset ${isCollapsed ? 'collapsed' : ''}`}>
      <legend onClick={() => setIsCollapsed(!isCollapsed)}>
        <span className='label' >{title}</span>
        <span className="accordion-toggle" aria-label="Toggle Section">
          {isCollapsed ? '▼' : '▲'}
        </span>
      </legend>
      {!isCollapsed && <div className="accordion-content">{children}</div>}
    </fieldset>
  );
};

export default AccordionFieldset;
